export const FETCH_REQUESTS = "FETCH_REQUESTS";
export const REFRESH_REQUEST = "REFRESH_REQUEST";
export const REFRESH_REQUESTS = "REFRESH_REQUESTS";
export const CANCEL_REQUEST = "CANCEL_REQUEST";
export const FETCH_TRANSFERS = "FETCH_TRANSFERS";
export const INITIAITE_TRANSFER = "INITIAITE_TRANSFER";
export const FINALIZE_TRANSFER = "FINALIZE_TRANSFER";
export const GET_TRANSFER = "GET_TRANSFER";
export const CREATE_REQUEST = "CREATE_REQUEST";